module.exports = __webpack_public_path__ + "img/view.227190fc.svg";